export const VehicleViewConfig: VehicleViewConfig = {
  cards: [
    {
      title: "Basic Details",
      type: "vehicle",
      fields: [
        {
          label: "Name",
          value: "N/A",
          type: "text",
          key: "name",
          isVisible: false
        },
        {
          label: "Registration Number",
          value: "N/A",
          type: "text",
          key: "regNo",
          isVisible: false
        },
        {
          label: "Driver",
          value: "N/A",
          type: "text",
          key: "driverName",
          isVisible: false
        },
        {
          label: "Chassis Number",
          value: "N/A",
          type: "text",
          key: "chassis",
          isVisible: true
        },
        {
          label: "Engine Number",
          value: "N/A",
          type: "text",
          key: "engine",
          isVisible: true
        },
        {
          label: "Owner",
          value: "N/A",
          type: "text",
          key: "owner",
          isVisible: true
        },
        {
          label: "Owner Count",
          value: "N/A",
          type: "text",
          key: "ownerCount",
          isVisible: true
        },
        {
          label: "Short Name",
          value: "N/A",
          type: "text",
          key: "shortName",
          isVisible: true
        },
        {
          label: "Model",
          value: "N/A",
          type: "text",
          key: "model",
          isVisible: true
        },
        {
          label: "Color",
          value: "N/A",
          type: "text",
          key: "vehicleColour",
          isVisible: true
        },
        {
          label: "Category",
          value: "N/A",
          type: "text",
          key: "category",
          isVisible: true
        },
        {
          label: "Driver UserId",
          value: "N/A",
          type: "text",
          key: "driverUserId",
          isVisible: false
        }
      ]
    },
    {
      title: "Specifications",
      type: "specifications",
      fields: [
        {
          label: "Fuel Type",
          value: "N/A",
          type: "text",
          key: "type",
          isVisible: true
        },
        {
          label: "Seating Capacity",
          value: "N/A",
          type: "text",
          key: "vehicleSeatCapacity",
          isVisible: true
        },
        {
          label: "Norms Type",
          value: "N/A",
          type: "text",
          key: "normsType",
          isVisible: true
        },
        {
          label: "Cubic Capacity",
          value: "N/A",
          type: "text",
          key: "cubicCapacity",
          isVisible: true
        },
        {
          label: "Gross Vehicle Weight",
          value: "N/A",
          type: "text",
          key: "grossVehicleWeight",
          isVisible: true
        },
        {
          label: "Unladen Weight",
          value: "N/A",
          type: "text",
          key: "unladenWeight",
          isVisible: true
        },
        {
          label: "Cylinders Count",
          value: "N/A",
          type: "text",
          key: "cylindersCount",
          isVisible: true
        },
        {
          label: "Wheel Base",
          value: "N/A",
          type: "text",
          key: "wheelBase",
          isVisible: true
        }
      ]
    },
    {
      title: "Registration Details",
      type: "registration",
      fields: [
        {
          label: "Registration  Authority",
          value: "N/A",
          type: "text",
          key: "regAuthority",
          isVisible: true
        },
        {
          label: "Registration Date",
          value: "N/A",
          type: "text",
          key: "regDate",
          isVisible: true
        },
        {
          label: "Registration Certificate Validity Date",
          value: "N/A",
          type: "text",
          key: "rcExpiryDate",
          isVisible: true
        },
        {
          label: "Registration Certificate Documents",
          value: "N/A",
          type: "text",
          key: "regDocuments",
          isVisible: false
        }
      ]
    },
    {
      title: "Insurance Details",
      type: "insurance",
      fields: [
        {
          label: "Insurance Company Name",
          value: "N/A",
          type: "text",
          key: "vehicleInsuranceCompanyName",
          isVisible: true
        },
        {
          label: "Insurance Validity Date",
          value: "N/A",
          type: "text",
          key: "vehicleInsuranceUpto",
          isVisible: true
        },
        {
          label: "Insurance Policy Number",
          value: "N/A",
          type: "text",
          key: "vehicleInsurancePolicyNumber",
          isVisible: true
        },
        {
          label: "Insurance Certificate Documents",
          value: "N/A",
          type: "text",
          key: "insuranceDocuments",
          isVisible: false
        }
      ]
    },
    {
      title: "Permit Details",
      type: "permit",
      fields: [
        {
          label: "Permit No",
          value: "N/A",
          type: "text",
          key: "permitNumber",
          isVisible: true
        },
        {
          label: "Permit Type",
          value: "N/A",
          type: "text",
          key: "permitType",
          isVisible: true
        },
        {
          label: "Permit Validity Date",
          value: "N/A",
          type: "text",
          key: "permitValidUpto",
          isVisible: true
        },
        {
          label: "Permit Certificate Documents",
          value: "N/A",
          type: "text",
          key: "permitDocuments",
          isVisible: false
        }
      ]
    },
    {
      title: "Pollution Certificate Details",
      type: "pollution",
      fields: [
        {
          label: "Pollution Certificate Name",
          value: "N/A",
          type: "text",
          key: "puccNumber",
          isVisible: true
        },
        {
          label: "Pollution Certificate Validity Date",
          value: "N/A",
          type: "text",
          key: "puccUpto",
          isVisible: true
        },
        {
          label: "Pollution Certificate Documents",
          value: "N/A",
          type: "text",
          key: "pollutionDocuments",
          isVisible: false
        }
      ]
    },
    {
      title: "Student Details",
      type: "student",
      tableheaders: [
        {key: "name", label: "Name"},
        {key: "parentName", label: "Parent"},
        {key: "phone", label: "Phone"},
        {key: "userClass", label: "Class"}
      ],
      tablerows: [],
      fields: [
        {
          label: "Name",
          value: "N/A",
          type: "text",
          key: "name",
          isVisible: true
        },
        {
          label: "Parents Name",
          value: "N/A",
          type: "text",
          key: "parentName",
          isVisible: true
        },
        {
          label: "Phone No",
          value: "N/A",
          type: "text",
          key: "phone",
          isVisible: true
        },
        {
          label: "Class",
          value: "N/A",
          type: "text",
          key: "userClass",
          isVisible: true
        }
      ]
    }
  ]
};
